import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_BODY_ROW_DRAGGABLE_CLASS_NAME = 'TableBodyRowDraggable';

export const TABLE_BODY_ROW_DRAGGABLE_CLASS_SLOTS = ['root'] as const;

export type TableBodyRowDraggableClassSlot =
	(typeof TABLE_BODY_ROW_DRAGGABLE_CLASS_SLOTS)[number];

export interface TableBodyRowDraggableClasses {
	root: string;
	isDragGhost: string;
	isDragging: string;
	shifted: string;
}

export type TableBodyRowDraggableClassKey = keyof TableBodyRowDraggableClasses;

export const getTableBodyRowDraggableUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_BODY_ROW_DRAGGABLE_CLASS_NAME, slot);

export const tableBodyRowDraggableClasses = generateUtilityClasses<
	keyof TableBodyRowDraggableClasses
>(TABLE_BODY_ROW_DRAGGABLE_CLASS_NAME, [
	'root',
	'isDragGhost',
	'isDragging',
	'shifted',
]);
export default tableBodyRowDraggableClasses;
